var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,25.1c-1.1,0-2-0.9-2-2V7.6c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v15.6C38.5,24.3,37.6,25.1,36.5,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,51.1c-1.1,0-2-0.9-2-2v-37c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v37C22.8,50.3,22,51.1,20.9,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,51.1c-1.1,0-2.2-0.3-3.2-0.8L5.9,44.5c-1.6-0.8-2.5-2.3-2.5-4.1V10.9c0-1.5,0.7-2.8,1.9-3.7 C6.4,6.4,8,6.1,9.3,6.6l10.5,3.5c0.7,0.2,1.4,0.2,2.1,0L34.2,6c1.5-0.5,3-0.5,4.5,0l12.2,4.1c1.9,0.6,3.1,2.4,3.1,4.3v11.4 c0,1.1-0.9,2-2,2s-2-0.9-2-2V14.4c0-0.3-0.2-0.5-0.4-0.6L37.5,9.7c-0.7-0.2-1.4-0.2-2.1,0l-12.3,4.1c-1.5,0.5-3.1,0.5-4.5,0 L8.1,10.3c-0.3-0.1-0.5,0-0.6,0.1c-0.1,0.1-0.3,0.2-0.3,0.5v29.5c0,0.2,0.1,0.5,0.4,0.6l11.8,5.9c0.9,0.5,2,0.5,2.9,0l5.5-2.7 c1-0.5,2.1-0.1,2.6,0.9c0.5,1,0.1,2.1-0.9,2.6l-5.5,2.7C23.1,50.9,22,51.1,20.9,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,56.3c-1.1,0-2.3-0.4-3.2-1.3c-2.9-2.9-7.9-8.5-7.9-14.1c0-6.1,5-11.1,11.1-11.1s11.1,5,11.1,11.1 c0,5.3-4.3,10.6-7.9,14.1l0,0C47.9,55.9,46.7,56.3,45.6,56.3z M47.4,53.7L47.4,53.7L47.4,53.7z M45.6,33.8c-3.9,0-7.2,3.2-7.2,7.2 c0,3,2.4,7.1,6.7,11.3c0.3,0.2,0.6,0.2,0.9,0c4.3-4.1,6.7-8.3,6.7-11.3C52.8,37,49.6,33.8,45.6,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,43.4c-1.4,0-2.6-1.2-2.6-2.6c0-0.7,0.3-1.4,0.8-1.9c0.5-0.5,1.2-0.8,1.9-0.8c1.5,0,2.6,1.2,2.6,2.6 C48.2,42.2,47.1,43.4,45.6,43.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlan);
export default __webpack_public_path__ + "static/media/ic_plan.ec95bb7a65b52e3ff013a98f3f79f44d.svg";
export { ForwardRef as ReactComponent };